module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_2a-af5b96080355889bf0a6889e1c251b61.jpg";